import { render, staticRenderFns } from "./SurgEdit.vue?vue&type=template&id=4dcae3b2"
import script from "./SurgEdit.vue?vue&type=script&lang=js"
export * from "./SurgEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports